import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { MainMenuRoute } from '@base/enums/main-menu-route.enum';
import { EventService } from '@base/services/private/event.service';

export const isBrandedCanMatch: CanMatchFn = (_route, segments) => {
  const eventSrv = inject(EventService);
  const isBranded = eventSrv.data?.isBrandedDomain ?? false;
  if (!isBranded) {
    return false;
  }

  const firstUrlSegment = segments[0]?.path ?? '';
  if (!firstUrlSegment) {
    return true;
  }

  return Object.values(MainMenuRoute).includes(firstUrlSegment as MainMenuRoute);
};

export const isUnbrandedCanMatch: CanMatchFn = () => {
  const eventSrv = inject(EventService);
  const isBranded = eventSrv.data?.isBrandedDomain ?? false;
  if (!isBranded) {
    return true;
  }

  return false;
};
